import React from "react";

interface SectionHeaderProps {
  section: any;
}

const SectionHeader: React.FC<SectionHeaderProps> = ({ section }) => {
  if (!section) {
    return null;
  }

  /*
   * ---------------------------------------------------------
   * ONLY CUSTOM SECTIONS GET A GENERIC SECTION HEADER
   * ---------------------------------------------------------
   *
   * API can return ContentType as:
   *
   *   "Custom"
   *
   * or numeric enum:
   *
   *   7
   *
   * We support both.
   */
  const isCustom =
    typeof section.contentType === "string"
      ? section.contentType.toLowerCase() === "custom"
      : Number(section.contentType) === 7;

  if (!isCustom) {
    return null;
  }

  /*
   * ---------------------------------------------------------
   * SECTION TITLE
   * ---------------------------------------------------------
   *
   * Prefer DisplayName because that is what the admin
   * controls for customer-facing display.
   *
   * Fall back to SectionName if DisplayName is empty.
   */
  const title = section.displayName || section.sectionName || "";

  /*
   * Section description is optional.
   */
  const description = section.description || "";

  /*
   * Don't render an empty header.
   */
  if (!title && !description) {
    return null;
  }

  return (
    <div className="w-full">
      {/* ---------------------------------------------------
          Section Title
          Same general styling as existing section headings.
      --------------------------------------------------- */}
      {title && (
        <h2 className="text-logoHeading text-base md:text-xl font-bold">
          {title}
        </h2>
      )}

      {/* ---------------------------------------------------
          Section Subtitle / Description
      --------------------------------------------------- */}
      {description && (
        <p className="mt-1 text-xs text-slate-400 font-medium">{description}</p>
      )}
    </div>
  );
};

export default SectionHeader;
